import { IconProps } from "@design-system/types";

export function TwitterIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.188952 0.467041L7.85693 10.7197L0.140625 19.0556H1.87739L8.63316 11.7572L14.0914 19.0556H20.0013L11.9017 8.22634L19.0841 0.467041H17.3473L11.1258 7.18848L6.09883 0.467041H0.188952ZM2.74295 1.7462H5.45792L17.447 17.7764H14.732L2.74295 1.7462Z"
        fill="white"
      />
    </svg>
  );
}
